export default __webpack_public_path__ + "static/media/information--dead-end--g2.313e9231.png";